import React from "react";
import { cn } from "@/utils/cn";

interface MediaGridMobileProps {
  children: React.ReactNode;
  className?: string;
}

export const MediaGridMobile: React.FC<MediaGridMobileProps> = ({
  children,
  className,
}) => {
  return (
    <div
      className={cn(
        // 3 columns edge-to-edge (no gap)
        "grid grid-cols-3 gap-0",
        // Instagram profile grid feel
        "w-full",
        className
      )}
    >
      {children}
    </div>
  );
};
